import { userService } from "@/api/userService";
import { usePaginatedResource } from "@/hooks/usePaginatedResource";

const defaultFilters = {
  status: "",
  institution__name: "",
  search: "",
  identifier: "",
};
export const useUsers = () => usePaginatedResource(userService, defaultFilters);
